const labels = {
  paymentFormError: 'payment.form.error',
  loadTime: 'payment.form.loadTime',
  libraryLoadTime: 'payment.library.loadTime',
  productLoadFailed: 'product.load.failed',
};

const action = {
  submit: 'submit',
};

export default {
  labels,
  action,
};
